// extracted by mini-css-extract-plugin
export default {"modalOverlay":"nA-z","modalContent":"oA-z","header":"pA-z","close":"qA-z"};